import React, { forwardRef } from 'react';
import { Card } from 'react-bootstrap';

const Rules = forwardRef((props, ref) => {
 return (
  <Card className="mb-3" id="rules" ref={ref}>
   <Card.Header className="bg-light">
    <h5 className="mb-0">Política de reglas y abuso:</h5>
   </Card.Header>
   <Card.Body>
    <h6 className="text-primary">Reglas Generales</h6>
    <p className="fs-0 mb-0 fw-semi-bold">Se espera que el usuario siga reglas específicas como:</p>
    <ol type="1">
     <li>
      no enviar spam, no utilizar listas de correo electrónico adquiridas o de terceros, cumplir con la política de uso aceptable
      y cumplir con las leyes de protección de datos.
     </li>
     <li>Si se viola alguna regla, se puede suspender o cancelar la cuenta.</li>
     <li>El usuario debe brindar cooperación y cumplir con las leyes aplicables.</li>
     <li>Si cree que alguien está violando los términos, se deben informar de inmediato.</li>
     <hr className="my-4" />
    </ol>
    <h6 className="text-primary">Política de Responsabilidad</h6>
    <p className="fs-0 mb-0 fw-semi-bold">Responsabilidad por pérdidas o daños para empresas</p>
    <ol type="1">
     <li>
      Nosotros no somos responsables por cualquier pérdida o daño relacionado con:
      <ol type="2">
       <li>El uso que haga del Servicio</li>
       <li>Representaciones, declaraciones o acciones ilegales o negligencia relacionada con estos Términos</li>
      </ol>
      <li>Representaciones, declaraciones o acciones ilegales o negligencia relacionada con estos Términos</li>
     </li>
     <p className="mb-0 ps-3">
      Usted asume la responsabilidad exclusiva por los resultados de su uso del Servicio y las conclusiones derivadas de dicho
      uso. No seremos responsables por daños causados por errores o omisiones en información proporcionada por usted, ni por
      acciones tomadas bajo su dirección.
     </p>
    </ol>
    <hr className="my-4" />
    <h6 className="text-primary">Exclusión de garantías y responsabilidad</h6>
    <p className="mb-0 ps-3">
     Todas las garantías, representaciones, condiciones y todos los demás términos implícitos están excluidos en la medida
     permitida por la ley aplicable. El Servicio se le brinda tal cual.
    </p>
    <hr className="my-4" />
    <h6 className="text-primary">Responsabilidad por muerte o lesiones personales y fraude</h6>

    <li>
     No excluimos nuestra responsabilidad por muerte o lesiones personales causadas por nuestra negligencia o fraude o
     tergiversación fraudulenta.
    </li>
    <br />
    <h6 className="text-primary">Limitación de Responsabilidad</h6>
    <li>
     No seremos responsables por lucro cesante, pérdida de negocios, pérdida de fondo de comercio, corrupción de datos, pérdida
     económica, costos indirectos o daños consecuentes que surjan de estos Términos, salvo por nuestra responsabilidad por muerte
     o lesiones personales y fraude.
    </li>
    <br />
    <h6 className="text-primary">Responsabilidad por pérdidas o daños para consumidores</h6>
    <li>
     Somos responsables ante los consumidores por las pérdidas y daños previsibles causados por nosotros. No excluimos ni
     limitamos de ninguna manera nuestra responsabilidad hacia los consumidores cuando sea ilegal hacerlo, incluyendo
     responsabilidad por muerte o lesiones personales causadas por nuestra negligencia o la de nuestros empleados, agentes o
     subcontratistas, y por fraude o tergiversación fraudulenta. No somos responsables por pérdidas comerciales
    </li>
    <br />
    <h6 className="text-primary">Fuerza mayor</h6>
    <li>
     No seremos responsables por retrasos o fallas en el desempeño del Servicio causados por circunstancias fuera de nuestro
     control, incluyendo cambios en leyes o reglamentos, incendios, terremotos, huelgas, apagones y condiciones climáticas
     extremas.
    </li>
   </Card.Body>
  </Card>
 );
});

export default Rules;
